import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CustomTabs from "utilFunctions/shared/CustomTabs";

const StudentPerformanceTabsMain = ({ tabs }: any) => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<number>(0);
  useEffect(() => {
    const { state } = location;
    if (state && state.studentTab && state.studentTab != null) {
      setActiveTab(state.studentTab);
    }
  }, [location]);
  return (
    <CustomTabs
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      tabs={tabs}
      className=""
    />
  );
};
export default StudentPerformanceTabsMain;
